(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-results.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-results.js');
"use strict";

var _svs$core$session;
const {
  useMemo
} = React;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useTeamsIds
} = svs.components.marketplaceCompetition.services.hooks;
const {
  usePersonalResults,
  usePlayerCompetitions
} = svs.components.marketplaceCompetition.services.hooks;
const {
  FetchState
} = svs.components.marketplaceCompetition.constants;
const {
  PersonalResultsIndividual,
  PersonalResultsTeam
} = svs.components.marketplaceCompetition.routeResult.personalResults;
const {
  firstName,
  lastName
} = (_svs$core$session = svs.core.session) === null || _svs$core$session === void 0 || (_svs$core$session = _svs$core$session.data) === null || _svs$core$session === void 0 ? void 0 : _svs$core$session.userSession;
const sortByTeamName = (a, b) => {
  if (a.teamName > b.teamName) {
    return 1;
  }
  if (b.teamName > a.teamName) {
    return -1;
  }
  return 0;
};
const sortByPlacement = (a, b) => {
  if (a.position.current > b.position.current) {
    return 1;
  }
  if (b.position.current > a.position.current) {
    return -1;
  }
  return sortByTeamName(a, b);
};
const sortTeams = (a, b) => {
  if (a.status === FetchState.Pending && b.status === FetchState.Pending) {
    return 0;
  } else if (a.status !== FetchState.Pending && b.status === FetchState.Pending) {
    return 1;
  } else if (a.status === FetchState.Pending && b.status !== FetchState.Pending) {
    return -1;
  }
  return sortByPlacement(a.data, b.data);
};
const PersonalResults = _ref => {
  let {
    showIndividual = true,
    showTeams = true
  } = _ref;
  const competitionId = useCompetitionId();
  const playerCompetitions = usePlayerCompetitions();
  const personalTeams = useTeamsIds(competitionId);
  const personalResult = usePersonalResults(competitionId, personalTeams);
  const isUserRegisteredInCompetition = competitionId && (playerCompetitions === null || playerCompetitions === void 0 ? void 0 : playerCompetitions[competitionId]);
  const {
    individual,
    teams
  } = personalResult ? personalResult : {};
  const teamsArr = useMemo(() => {
    if (!teams) {
      return [];
    }
    return Object.values(teams).sort(sortTeams);
  }, [teams]);
  if (!isUserRegisteredInCompetition || !individual && !teams) {
    return null;
  }
  return React.createElement("div", {
    className: "personal-result-container data-hj-suppress"
  }, showIndividual && React.createElement(PersonalResultsIndividual, {
    firstname: firstName,
    individual: individual,
    lastname: lastName
  }), showTeams && teamsArr && teamsArr.map(t => React.createElement(PersonalResultsTeam, {
    key: t.data.id,
    team: t
  })));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.personalResults.PersonalResults', PersonalResults);

 })(window);